var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVicDriverLicenceBackVerifyIdentity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 116,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335 0v116H0V0h335z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159 0c6.075 0 11 4.925 11 11v92c0 6.075-4.925 11-11 11H11c-6.075 0-11-4.925-11-11V11C0 4.925 4.925 0 11 0h148z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.288 0v8.46H1.824V1.5l-1.512.42L0 .72 2.268 0h1.02z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.216 0C4.86 0 5.988 1.008 5.988 2.508v.024c0 1.32-.696 2.04-2.184 3.252l-1.728 1.44h3.996V8.52H0V7.356l2.892-2.46c1.152-.984 1.572-1.512 1.572-2.268 0-.828-.588-1.308-1.356-1.308-.768 0-1.296.42-1.932 1.26L.12 1.752C.924.636 1.716 0 3.216 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.024 0v1.104l-2.34 2.4c1.272.156 2.472.804 2.472 2.352v.024c0 1.548-1.188 2.664-2.94 2.664C1.752 8.544.708 7.932 0 7.068l1.032-.96c.6.708 1.272 1.104 2.208 1.104.828 0 1.452-.504 1.452-1.272v-.024c0-.828-.756-1.296-1.932-1.296h-.684l-.24-.924 2.268-2.412H.468V0h5.556z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.928 0v5.364h1.2v1.212h-1.2V8.46H4.512V6.576H.276L0 5.52 4.668 0h1.26zM4.512 2.04l-2.76 3.324h2.76V2.04z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.832 0v1.308H2.076l-.132 1.968c.396-.144.768-.24 1.332-.24 1.632 0 2.928.864 2.928 2.64V5.7c0 1.716-1.26 2.844-3.12 2.844C1.8 8.544.792 8.028 0 7.26l.912-1.068c.672.624 1.38 1.008 2.16 1.008 1.008 0 1.668-.576 1.668-1.452v-.024c0-.852-.72-1.392-1.74-1.392-.6 0-1.116.168-1.548.372l-.888-.588L.804 0h5.028z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6 0c1.092 0 1.836.348 2.568.936l-.792 1.14c-.588-.456-1.08-.732-1.824-.732-1.464 0-1.992 1.524-2.016 2.676.492-.516 1.116-.852 2.016-.852 1.62 0 2.928.96 2.928 2.64v.024c0 1.668-1.356 2.856-3.12 2.856-1.032 0-1.776-.324-2.34-.888C.384 7.164 0 6.288 0 4.596v-.024C0 2.004 1.224 0 3.6 0zm-.312 4.404c-1.044 0-1.704.672-1.704 1.476v.024c0 .852.696 1.5 1.74 1.5s1.68-.648 1.68-1.512v-.024c0-.84-.672-1.464-1.716-1.464z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.904 0v1.116L2.124 8.4H.456l3.768-7.104H0V0h5.904z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.204 0C4.884 0 6.12.972 6.12 2.268v.024c0 .936-.516 1.5-1.224 1.872.924.42 1.512 1.02 1.512 2.016v.024c0 1.5-1.368 2.436-3.204 2.436S0 7.68 0 6.228v-.024c0-1.008.564-1.644 1.512-2.04C.804 3.792.288 3.228.288 2.292v-.024C.288.984 1.524 0 3.204 0zm0 4.848c-.996 0-1.752.504-1.752 1.272v.024c0 .684.648 1.26 1.752 1.26s1.764-.564 1.764-1.26V6.12c0-.768-.768-1.272-1.764-1.272zm0-3.612c-.9 0-1.5.528-1.5 1.164v.024c0 .732.636 1.248 1.5 1.248s1.5-.516 1.5-1.236v-.024c0-.648-.6-1.176-1.5-1.176z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.054 0C6.86 0 7.952.63 8.89 1.526L7.784 2.8C7 2.072 6.16 1.582 5.04 1.582c-1.862 0-3.234 1.54-3.234 3.458v.028c0 1.918 1.358 3.472 3.234 3.472 1.204 0 1.974-.476 2.814-1.26L8.96 8.4c-1.022 1.064-2.142 1.736-3.976 1.736C2.128 10.136 0 7.91 0 5.096v-.028C0 2.282 2.086 0 5.054 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.43 0c1.106 0 1.932.294 2.45.826.546.532.798 1.316.798 2.282V7.49H5.026v-.924c-.504.602-1.274 1.078-2.408 1.078C1.232 7.644 0 6.846 0 5.362v-.028c0-1.596 1.246-2.38 3.052-2.38.826 0 1.414.126 1.988.308V3.08c0-1.05-.644-1.61-1.834-1.61-.826 0-1.442.182-2.114.462L.644.602C1.456.238 2.254 0 3.43 0zm-.042 4.032c-1.092 0-1.736.462-1.736 1.232v.028c0 .714.63 1.12 1.442 1.12 1.12 0 1.974-.644 1.974-1.582v-.504a4.696 4.696 0 0 0-1.68-.294z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.11 0l.202.003v1.792h-.098c-1.484 0-2.52.966-2.52 2.926v2.814H0V.143h1.694v1.666C2.156.703 3.01-.053 4.312.003z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.644 0v10.22H5.95V8.988c-.546.77-1.316 1.386-2.52 1.386C1.694 10.374 0 8.988 0 6.538V6.51c0-2.45 1.666-3.836 3.43-3.836 1.218 0 1.988.602 2.52 1.302V0h1.694zM3.836 4.144c-1.162 0-2.128.896-2.128 2.366v.028c0 1.428.98 2.366 2.128 2.366 1.134 0 2.142-.952 2.142-2.366V6.51c0-1.428-1.008-2.366-2.142-2.366z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.004 0C5.67 0 6.636 1.12 6.636 2.828v4.718H4.942v-4.2c0-1.148-.574-1.806-1.582-1.806-.98 0-1.666.686-1.666 1.834v4.172H0V.154h1.694v1.134C2.17.602 2.856 0 4.004 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.694 0v4.2c0 1.148.574 1.792 1.582 1.792.98 0 1.666-.672 1.666-1.82V0H6.65v7.392H4.942V6.244c-.476.7-1.162 1.302-2.31 1.302C.966 7.546 0 6.426 0 4.704V0h1.694z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.652 0c1.61 0 2.59 1.022 2.59 2.828v4.718H9.548v-4.2c0-1.176-.546-1.806-1.498-1.806-.924 0-1.582.644-1.582 1.834v4.172H4.774V3.332c0-1.148-.56-1.792-1.498-1.792s-1.582.7-1.582 1.834v4.172H0V.154h1.694v1.12C2.17.616 2.814 0 3.948 0c1.064 0 1.82.518 2.212 1.302C6.748.518 7.532 0 8.652 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.694 0v4.06c.546-.77 1.316-1.386 2.52-1.386 1.736 0 3.43 1.372 3.43 3.836v.028c0 2.45-1.68 3.836-3.43 3.836-1.232 0-2.002-.616-2.52-1.302v1.148H0V0h1.694zm2.114 4.144c-1.148 0-2.156.952-2.156 2.366v.028c0 1.414 1.008 2.366 2.156 2.366 1.162 0 2.114-.91 2.114-2.366V6.51c0-1.428-.966-2.366-2.114-2.366z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.612 0c2.352 0 3.542 1.848 3.542 3.976 0 .154-.014.308-.028.476H1.694c.182 1.204 1.036 1.876 2.128 1.876.826 0 1.414-.308 2.002-.882l.994.882c-.7.84-1.666 1.386-3.024 1.386C1.652 7.714 0 6.16 0 3.878V3.85C0 1.736 1.498 0 3.612 0zm-.014 1.386c-1.036 0-1.764.798-1.918 1.946h3.794c-.112-1.092-.756-1.946-1.876-1.946z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.11 0l.202.003v1.792h-.098c-1.484 0-2.52.966-2.52 2.926v2.814H0V.143h1.694v1.666C2.156.703 3.01-.053 4.312.003z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.312 0l8.312 16.624H0L8.312 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.77 0c8.235 0 13.68 7.2 13.68 16.2v.09c0 9-5.49 16.29-13.77 16.29S0 25.38 0 16.38v-.09C0 7.29 5.49 0 13.77 0zm-.09 4.995c-4.86 0-7.965 4.95-7.965 11.205v.09c0 6.21 3.15 11.295 8.055 11.295 4.905 0 7.965-5.04 7.965-11.205v-.09c0-6.21-3.195-11.295-8.055-11.295z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.33 0v31.725H6.84v-26.1L1.17 7.2 0 2.7 8.505 0h3.825z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.32 0v5.355H0V0h13.32z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.77 0c8.235 0 13.68 7.2 13.68 16.2v.09c0 9-5.49 16.29-13.77 16.29S0 25.38 0 16.38v-.09C0 7.29 5.49 0 13.77 0zm-.09 4.995c-4.86 0-7.965 4.95-7.965 11.205v.09c0 6.21 3.15 11.295 8.055 11.295 4.905 0 7.965-5.04 7.965-11.205v-.09c0-6.21-3.195-11.295-8.055-11.295z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.33 0v31.725H6.84v-26.1L1.17 7.2 0 2.7 8.505 0h3.825z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "translate(82 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h170v114H0V0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93 1h148c6.075 0 11 4.925 11 11v92c0 6.075-4.925 11-11 11H93c-6.075 0-11-4.925-11-11V12c0-6.075 4.925-11 11-11z",
    stroke: "#969696",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(180.312 53.54)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h3.288v8.46H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    transform: "translate(185.34 53.48)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.072v8.52H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(192.624 53.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.156v8.544H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "translate(199.956 53.54)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.128v8.46H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "translate(208.272 53.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.204v8.544H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "translate(215.868 53.456)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.48v8.688H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "translate(223.656 53.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h5.904v8.4H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "translate(230.604 53.48)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.408v8.64H0V0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "translate(268.455 41.032)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h8.96v10.136H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "translate(278.535 43.51)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.678v7.644H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "translate(287.243 43.465)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h4.312v7.535H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    transform: "translate(292.437 40.78)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.644v10.374H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "translate(268.693 57.454)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.636v7.546H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    transform: "translate(277.289 57.608)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.65v7.546H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)",
    transform: "translate(286.053 57.454)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h11.242v7.546H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)",
    transform: "translate(299.353 54.78)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.644v10.374H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)",
    transform: "translate(308.34 57.454)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.154v7.714H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)",
    transform: "translate(317.203 57.465)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h4.312v7.535H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)",
    transform: "rotate(-90 154.312 -88.688)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B81236",
    d: "M0 0h16.624v16.624H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)",
    transform: "translate(107.565 17.96)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M0 0h27.45v32.58H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)",
    transform: "translate(138.525 18.275)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M0 0h12.33v31.725H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)",
    transform: "translate(157.695 33.53)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M0 0h13.32v5.355H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)",
    transform: "translate(176.1 17.96)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M0 0h27.45v32.58H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)",
    transform: "translate(207.06 18.275)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M0 0h12.33v31.725H0V0z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVicDriverLicenceBackVerifyIdentity);
export default __webpack_public_path__ + "static/media/vic_driver_licence_back_verify_identity.f22942571336ac2bb767757c9503bbee.svg";
export { ForwardRef as ReactComponent };